<template>
  <div v-if="hasTechnicalSpecification || hasDescription">
    <div class="container-lg">
      <div v-if="hasDescription" class="tabs">
        <div class="tabs__nav">
          <div class="tabs__nav-item active">
            {{ in18['page_product_description'] }}
          </div>
        </div>
        <div class="tabs__content">
          <div class="text" v-html="product.description"/>
        </div>
      </div>
      <div v-if="hasTechnicalSpecification" class="tabs">
        <div class="tabs__nav">
          <div class="tabs__nav-item active">
            {{ in18['page_product_technical_specification'] }}
          </div>
        </div>
        <div class="tabs__content">
            <div class="row">
            <div class="col-lg-6">
              <template
                  v-for="(group, groupIndex) in product.property_groups.slice(0, Math.ceil(product.property_groups.length / 2))">
                <h3 class="tabs__title">
                  {{ group.group_name }}
                </h3>
                <table class="tabs__table">
                  <tr v-for="(property, propIndex) in group.properties" :key="propIndex">
                    <td>{{ property.property_title }}</td>
                    <td class="text-dark fw-500">{{ property.selected_option_value }}</td>
                  </tr>
                </table>
              </template>
            </div><!-- /.col -->
            <div class="col-lg-6">
              <template v-for="group in product.property_groups.slice(Math.ceil(product.property_groups.length / 2))">
                <h3 class="tabs__title">
                  {{ group.group_name }}
                </h3>
                <table class="tabs__table">
                  <tr v-for="(property, propIndex) in group.properties" :key="propIndex">
                    <td>{{ property.property_title }}</td>
                    <td class="text-dark fw-500">{{ property.selected_option_value }}</td>
                  </tr>
                </table>
              </template>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div>
      </div>
    </div><!-- /.container -->

    <div class="container-lg">
      <hr>
    </div>
  </div>
</template>

<script>

export default {
  name:  'ProductInfoTabs',
  props: {
    product: Object,
    in18:       {
      type: Object,
    },
  },
  computed: {
    hasTechnicalSpecification() {
      return this.product.property_groups && this.product.property_groups.length > 0;
    },
    hasDescription() {
      return this.product.description && this.product.description.trim() !== '';
    },
  },
};
</script>